export class ShipmentStatusRequest{
    unitId?:number;
    saleOrderId?:number;
    masterBrandId?:number;
    selectedLoadingFromDate?:any;
    selectedLoadingToDate?:any;
}




export class ShipmentDetailRequest{
    saleOrderId?:number;
    masterBrandId?:number;
    invoiceNumber?:string;
    unitId?:number;
    companyId?:number;
    financialYear?:string;
    fromDate? : Date;
    toDate?: Date;

    constructor( saleOrderId?:number,
        masterBrandId?:number,
        invoiceNumber?:string,
        unitId?:number,companyId?:number,financialYear?:string,fromDate?:Date,toDate?:Date){

        this.saleOrderId = saleOrderId;
        this.masterBrandId = masterBrandId;  
        this.invoiceNumber = invoiceNumber;
        this.unitId = unitId;  
        this.companyId = companyId;
        this.financialYear = financialYear;
        this.fromDate = fromDate
        this.toDate = toDate

    }
    
}